export default function (colors) {
  let style = document.documentElement.style;

  const baseColors = {
    'main-bar-color': '#3580be',
    'tab-bar-color': '#3580be',
    'button-color': '#3580be',
    'block-head-color': '#3580be',
    'table-head-color': '#3580be',
    'list-head-color': '#3580be',
    'link-color': '#3580be',
    'text-black-color': '#3c4858',
    'text-grey-color': '#aaa',
    'text-light-grey-color': '#ccc',
  };

  for (let key of Object.keys(colors)) {
    const color = colors[key] ? `#${colors[key]}` : baseColors[key];
    style.setProperty("--md-theme-" + key, color);
  }
}
